
export const setMetaTag = (key, value) => {
  if (document && document.head) {
    let tag = document.head.querySelector(`meta[property="${key}"]`);
    if (tag) {
      tag.setAttribute('content', value);
    } else {
      tag = document.createElement('meta');
      tag.setAttribute('property', key);
      tag.setAttribute('content', value);

      document.head.appendChild(tag);
    }
  }
}

export const resetMetaTags = () => {
  // if there are no moments and this page is somehow shared,
  // then just share the CL marketing page.
  setMetaTag('og:url', 'https://www.capturelife.com');
  setMetaTag('og:title', 'CaptureLife - Make Every Moment Count');
  setMetaTag('og:type', 'website');
}
